export default __webpack_public_path__ + "static/media/atm.2cea35e8.jpeg";